/* eslint-disable no-magic-numbers, no-underscore-dangle */
/* global L, setTimeout */

import 'expose-loader?L!leaflet';
import 'leaflet.markercluster';

L.ProjectMarker = L.Marker.extend({
  setProjectProperties(project) {
    this.project = project;

    return this;
  },
});

L.projectMarker = function (latlng, options) {
  return new L.ProjectMarker(latlng, options);
};

export default {
  template: '<div></div>',
  props: ['map', 'projects', 'show', 'zoom'],
  mounted() {
    this.topProjects = L.markerClusterGroup({
      maxClusterRadius: 150,
      showCoverageOnHover: false,
      iconCreateFunction: (cluster) => {
        const projects = cluster.getAllChildMarkers()
          .map(projectMarker => projectMarker.project)
          .slice(0, 4);

        return this._getProjectIcon(projects);
      },
    });
  },
  methods: {
    _getProjectIcon(projects) {
      let iconHTML = '';
      let classes = 'top-project';
      if (projects.length >= 2) {
        iconHTML = projects.map(project => `
          <img src="${project.logo}"
            class="top-project__project top-project__project--small"
          ">`)
          .join('');
        classes += projects.length === 3 ? ' top-project--odd' : '';
      } else if (projects.length === 1) {
        iconHTML = `
          <img src="${projects[0].logo}"
            class="top-project__project"
           ">`;
      }

      return L.divIcon({
        className: classes,
        html: iconHTML,
        iconSize: 100,
      });
    },
    refreshProjectMarkers() {
      const self = this;
      if (this.topProjects) this.topProjects.clearLayers();
      if (this.show) {
        const logoMarkers = this.projects.map(project => {
          const center = L.latLng(project.areas[0].refPoint);
          const projectIcon = this._getProjectIcon([project]);

          return L.projectMarker(center, { icon: projectIcon })
            .setProjectProperties(project);
        });
        this.topProjects.addLayers(logoMarkers);
        this.topProjects.on('click clusterclick', (e) => {
          this.map.fireEvent('click', e);
        });
        this.topProjects.on('click', (e) => {
          this.map.flyTo(e.latlng, this.zoom);
        });

        setTimeout(() => {
          self.topProjects.addTo(self.map);
        }, 300);
      }
    },
  },
  watch: {
    projects: 'refreshProjectMarkers',
    map: 'refreshProjectMarkers',
    show: 'refreshProjectMarkers',
  },
};
